<template>
    <ai-tree-list-edit-wrapper
        ref="componentRef"
        :meta="metaData"
        height="100%"
        :action="action"
        :to-remove-toolbar-items-names="removeToolbarBtns"
        @tree-list-focus-changed="onTreeListFocusChanged"
        @treeListEditWrapperMounted="onTreeListEditWrapperMounted"
        @changesSavedSuccessfully="onChangesSavedSuccessfully"
        @dataLoaded="onDataLoadedHandler"
        @toolbar-button-click="onToolbarButtonClick"
        @cell-click='onCellClick'
        @refresh="onRefreshHandler"
        @user-settings-changed="onUserSettingsChanged"
        @user-data-changed="onUserDataChanged"
        @changesRemoved="onChangesRemoved"
        @userDataChangedLoaded="onUserDataChangedLoaded"
        class="qs-sxpr-sop-view"
    />
</template>
<script>
export default {
    name: 'qs-sxpr-sop-view',
};
</script>
<script setup>
import aiTreeListEditWrapper from '@/components/wrappers/ai-tree-list-edit-wrapper.vue';
import { setActiveViewInfo, setViewData } from '@/layouts/main-layout/main-layout-data';
import { computed, onMounted, ref } from 'vue';

const props = defineProps({
    action: {
        type: Object,
        default: () => {},
    },
    fromCard: {
        type: Boolean,
        default: () => false,
    },
});

// const refData = ref(null);
const isNsiChoice = ref(false);
const selectedNsiKod = ref(null);
const componentRef = ref(null);

const emit = defineEmits(['choose-nsi']);

onMounted(async () => {
    await onStart(); /// refData.value?.setDataSource();
});

const removeToolbarBtns = computed(() => {
    if (props.fromCard) {
        return removeToolbarBtnsList.filter(item => item !== 'choice');
    }
    return removeToolbarBtnsList;
});

const onStart = async (keySelect) => {
    // await componentRef.value?.ref.setDataSource();
    let keySelectFocus = keySelect ? keySelect : null;
    if(!keySelectFocus) {
        const dataTree = await componentRef.value?.ref.getTreeListDataSource();
        keySelectFocus = dataTree?.length ? dataTree[0].kod_sxp_sop : null;
        selectedNsiKod.value = keySelectFocus;
    }
    await componentRef.value?.ref.treeListInstance.option('focusedRowKey', keySelectFocus);
};

const onToolbarButtonClick = async (event) => {
    const componentName = event?.item?.component?.name;
    if (componentName === 'choice') {
        isNsiChoice.value = true;
        await beforeNsiClose();
    }
};

const beforeNsiClose = async () => {
    const canClose = await componentRef.value?.ref.checkBeforeClose();
    if (!canClose) return false;
    const dataTree = await componentRef.value?.ref.getTreeListDataSource();
    const nsiChoiceItem = await dataTree.find(item => {
        return item.kod_sxp_sop === selectedNsiKod.value;
    });
    emit('choose-nsi', nsiChoiceItem, isNsiChoice.value);
};

const onCellClick = async ({ viewId, event, key }) => {
    selectedNsiKod.value = key;
};

const onChangesRemoved = () => {
    emit('changesRemoved');
};

const onDataLoadedHandler = () => {
    emit('dataLoaded');
};

const onChangesSavedSuccessfully = () => {
    emit('changesSavedSuccessfully');
};

const onUserDataChangedLoaded = userData => {
    emit('userDataChangedLoaded', userData);
};

const onTreeListEditWrapperMounted = async () => {
    setActiveViewInfo({
        refresh: componentRef.value.ref.setDataSource,
        userData: () => {},
        userSettings: () => {},
    });

    await setViewData();
    emit('treeListEditWrapperMounted');
};
const onRefreshHandler = () => {
    emit('refresh');
};

const onUserDataChanged = args => {
    emit('userDataChanged', args);
};

const onTreeListFocusChanged = (row, viewId, rowIndex, component) => {
    emit('treeListFocusChanged', row, viewId, rowIndex, component);
};

const onUserSettingsChanged = (settings, autoSaveMode) => {
    emit('userSettingsChanged', settings, autoSaveMode);
};

defineExpose({
    beforeNsiClose: beforeNsiClose,
    onStart: (keySelect = null) => onStart(keySelect),
    onDataLoadedHandler,
    onRefreshHandler,
    onUserDataChanged,
    onUserSettingsChanged,
    onTreeListEditWrapperMounted,
    onChangesSavedSuccessfully,
    onChangesRemoved,
    onTreeListFocusChanged,
    onUserDataChangedLoaded,
    componentRef,
    onToolbarButtonClick,
    onCellClick

});

const removeToolbarBtnsList = ['choice', 'find-prev', 'find', 'find-start', 'find-next', 'expandOrCollapseButton',
    'copy', 'moveTo', 'moveSave', 'edit', 'searchPanel', 'export', 'show-column-chooser', 'cut', 'put'];

const metaData = {
    'keyExpr': 'kod_sxp_sop',
    'selectionMode': 'single',
    'selectButtonMode': 'single',
    'columns': [
        {
            'name': 'kod_sxp_sop',
            'caption': 'kod_sxp_sop',
            'dataField': 'kod_sxp_sop',
            'allowEditing': false,
            'width': 250,
            'index': 1,
            'visible': false,
        },
        {
            'name': 'name',
            'caption': 'Наименование',
            'dataField': 'name',
            'allowEditing': true,
            'width': '50%',
            'index': 2,
            'visible': true,
        },
        {
            'name': 'kod_r',
            'caption': 'kod_r',
            'dataField': 'kod_r',
            'allowEditing': false,
            'width': 250,
            'index': 3,
            'visible': false,
        },
        {
            'name': 'kpd',
            'caption': 'КПД теплообменников',
            'dataType': 'number',
            'alignment': 'left',
            'dataField': 'kpd',
            'allowEditing': true,
            'width': '50%',
            'index': 6,
            'visible': true,
        },
        {
            "name": "empty",
            "caption": "",
            "dataField": "empty",
            "allowEditing": false,
            'width': 30,
            'minWidth': 30,
            "index": 7,
            "visible": true
        }
    ],
    'api': {
        'select': 'tep-nsi./tep-nsi/qs-sxpr-sop/select/get',
        'save': 'tep-nsi./tep-nsi/qs-sxpr-sop/save/set',
    },
    'viewId': 'qs-sxpr-sop',
    'parentIdExpr': 'kod_r',
    'findTool': 'filter',
};

</script>
